import './styles.scss'
import Icon from '@components/Icon'

const CloseButton = ({ action, size = 'xs' }) => (
    <div onClick={action} className="close-button-x">
        <Icon type="close" size={size} />
    </div>
)

export default CloseButton
